import { GetPermissionInfoStatus, RecipientPermissionInfo, SharingTipId } from 'owa-sharing-data';
import { action } from 'satcheljs';

export const updateHasDLRecipient = action(
    'UPDATE_HAS_DL_RECIPIENT',
    (linkId: string, hasDLRecipient: boolean) => ({
        linkId: linkId,
        hasDLRecipient: hasDLRecipient,
    })
);

export const addRecipientsIntoLink = action(
    'ADD_RECIPIENTS_INTO_LINK',
    (linkId: string, recipients: RecipientPermissionInfo[]) => ({
        linkId: linkId,
        recipients: recipients,
    })
);

export const updateRecipientPermissionInfo = action(
    'UPDATE_RECIPIENT_PERMISSION_INFO',
    (
        linkId: string,
        emailAddress: string,
        hasAccess: boolean,
        canHaveAccess: boolean,
        getPermissionInfoStatus: GetPermissionInfoStatus
    ) => ({
        linkId: linkId,
        emailAddress: emailAddress,
        hasAccess: hasAccess,
        canHaveAccess: canHaveAccess,
        getPermissionInfoStatus: getPermissionInfoStatus,
    })
);

export const removeRecipientsFromLink = action(
    'REMOVE_RECIPIENTS_FROM_LINK',
    (linkId: string, recipients: RecipientPermissionInfo[]) => ({
        linkId: linkId,
        recipients: recipients,
    })
);

// Only used by view, but still here so that it will be lazy loaded, as it imports from owa-sharing-data.
// Consider moving to internalActions after owa-sharing-data is truely lazy
export const ignoreSharingTip = action(
    'IGNORE_SHARING_TIP',
    (linkId: string, sharingTipId: SharingTipId) => ({
        linkId: linkId,
        sharingTipId: sharingTipId,
    })
);
